import { useCfmContext } from "../Context/CfmContext";

/**
 * Custom hook that generates a sorted, deduplicated list of name options from the context state.
 *
 * @returns {Array<{ value: string, label: string }>} An array of option objects, each containing a unique name as both value and label.
 *
 * @example
 * const options = useNameOptions();
 * // options = [{ value: "Alice", label: "Alice" }, { value: "Bob", label: "Bob" }]
 *
 * @remarks
 * - Relies on the `useCfmContext` hook to access the current state.
 * - Filters out falsy names and removes duplicates.
 * - Returns an empty array if no details are available.
 */
const useNameOptions = () => {
  const { state } = useCfmContext();
  return (
    state.details
      ?.map((detail) => detail.name)
      .filter(Boolean)
      .filter((v, i, a) => a.indexOf(v) === i)
      .sort()
      .map((name) => ({ value: name, label: name })) || []
  );
};

export default useNameOptions;
